;$(function() {

    $('.accordion__name').click(function() {
        $(this).parent().toggleClass('active');
    });

});